export function isObject(value) {
    return value !== null && typeof value === "object";
}
const objProto = Object.prototype;
export function isRecordEmpty(rec) {
    for (const key in rec) {
        if (objProto.hasOwnProperty.call(rec, key)) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=object.js.map